<template>
    <template v-for="banner in banners">
        <PluginTrialBannerV2
            v-if="banner.key === 'plugin-trial-active'"
            :key="banner.key"
            :date="banner.date ?? undefined"
        />

        <TrialEndedBannerV2
            v-else-if="banner.key === 'plugin-trial-ended'"
            :key="banner.key"
            :date="banner.date ?? undefined"
            type="plugin"
        />

        <TrialEndedBannerV2
            v-else-if="banner.key === 'pro-trial-ended'"
            :key="banner.key"
            :date="banner.date ?? undefined"
            type="pro"
        />

        <SubscriptionBannerV2
            v-else-if="banner.key === 'plugin-subscription-lapsed'"
            :key="banner.key"
            type="plugin"
        />

        <SubscriptionBannerV2
            v-else-if="banner.key === 'pro-personal-subscription'"
            :key="banner.key"
            type="pro-personal"
        />

        <SubscriptionBannerV2
            v-else-if="banner.key === 'pro-team-subscription'"
            :key="banner.key"
            type="pro-team"
        />

        <InfoBannerV2
            v-else-if="banner.key === 'account-deleted'"
            :key="banner.key"
            show
            title="Your templates have been removed due to prolonged inactivity, and your profile is scheduled for permanent deletion in 30 days"
        >
            For more information on how to restore them, please contact our
            support team at support@topol.io.
        </InfoBannerV2>

        <InfoBannerV2
            v-else-if="
                banner.key === 'payment-request-due' && banner.paymentRequest
            "
            :key="banner.key"
            show
            :title="
                'Your payment for ' +
                banner.paymentRequest.name +
                ' is due soon'
            "
        >
            Please complete your payment of ${{
                banner.paymentRequest.formattedTotal
            }}
            by
            {{
                format(
                    new Date(banner.paymentRequest.due_date),
                    'd MMMM, yyyy'
                )
            }}
            to avoid any service issues.

            <inertia-link
                :href="
                    route('payment-requests.show', banner.paymentRequest.uuid)
                "
                class="font-semibold underline text-new-blue-500 hover:text-new-blue-600"
                >Click here to proceed.</inertia-link
            >
        </InfoBannerV2>

        <InfoBannerV2
            v-else-if="banner.key === 'team-storage-blocked'"
            :key="banner.key"
            show
            :dismissible="banner.dismissible"
            title="Your PRO storage has been blocked. You won't be able to use images in your templates."
            @dismiss="dismissBanner(banner)"
        >
            For more information on how to unblock it, please contact our
            support team at support@topol.io.
        </InfoBannerV2>

        <InfoBannerV2
            v-else-if="banner.key === 'api-token-storage-blocked'"
            :key="banner.key"
            show
            :dismissible="banner.dismissible"
            title="Your Plugin storage has been blocked for at least one of your API tokens."
            @dismiss="dismissBanner(banner)"
        >
            For more information on how to unblock it, please contact our
            support team at support@topol.io.
        </InfoBannerV2>
    </template>
</template>

<script setup lang="ts">
import { format } from 'date-fns';
import { route } from 'ziggy-js';
import useBanners from '@/composables/useBanners';
import InfoBannerV2 from './InfoBannerV2.vue';
import PluginTrialBannerV2 from './PluginTrialBannerV2.vue';
import SubscriptionBannerV2 from './SubscriptionBannerV2.vue';
import TrialEndedBannerV2 from './TrialEndedBannerV2.vue';

const { banners, dismissBanner } = useBanners();
</script>
